import {axi, GetListOutput, GetListParams} from '@shared/api';
import {validateData} from '@shared/utils';
import {UserBan, UserBanListItem} from '../types';
import {
  userBanListV8nSchema,
  v8nSchemaOfGetUserBansResponse,
} from './backendSchemas';
import {GetUserBansResponse, UserBanOnBackend} from './backendTypes';
import {mapUserBanFromBackend} from './dataMappers';

export interface GetBansParams extends GetListParams {
  active?: boolean;
}

export const getBans = async ({
  page,
  pageSize,
  active,
}: GetBansParams = {}): Promise<GetListOutput<UserBanListItem>> => {
  const response = await axi.get<GetUserBansResponse>('/admin/users/bans', {
    params: {page, per_page: pageSize, active},
  });
  validateData(response.data, v8nSchemaOfGetUserBansResponse, 'getBans');
  const data = response.data;
  return {
    page: data.page,
    pageSize: data.per_page,
    total: data.total,
    totalPages: data.total_pages,
    items: data.array.map(item => ({
      ...mapUserBanFromBackend(item),
      username: item.username,
    })),
  };
};

export const getUserBans = async (userId: string): Promise<UserBan[]> => {
  const response = await axi.get<UserBanOnBackend[]>(
    `/admin/users/${userId}/bans`,
  );
  validateData(response.data, userBanListV8nSchema, 'getUserBans');
  return response.data.map(item => mapUserBanFromBackend(item));
};

export interface BanUserParams {
  userId: string;
  comment: string;
}

export const banUser = async ({
  userId,
  comment,
}: BanUserParams): Promise<void> => {
  await axi.post(`/admin/users/${userId}/ban`, {comment});
};

export const unbanUser = async (userId: string): Promise<void> => {
  await axi.delete(`/admin/users/${userId}/ban`);
};
